import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {goBack} from '../../../services/utils/utility';
import {TranslateService} from '@ngx-translate/core';
import {LanguageChangeService} from '../../../services/language-change.service';
import {GDOService} from "../../../services/gdo.service";
import {GdoFilterActivity, IGDOHistory, ListHistory} from "../../models/hav-models";
import {Config} from "../../../services/utils/gdo-config";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {GdoHistoryFilterModalComponent} from "../gdo-history-filter/gdo-history-filter-modal.component";
import {Constants} from 'src/app/services/utils/Constants';

@Component({
  selector: 'app-gdo-history',
  templateUrl: './gdo-history.component.html',
  styleUrls: ['./gdo-history.component.css'],
})
export class GdoHistoryComponent implements OnInit {
  pageSize = 25;
  defaultPageNo = 1;
  pageNo = this.defaultPageNo;
  goBack = goBack;
  errorMessage: any;
  private id: string;
  disableCall = false;
  fromDate: number;
  toDate: number;
  filters: any = { setFilter: false };
  noRecordMsg = '';
  showError = false;
  currentScrollPosition: number = 0;
  //Selected Default Language
  langCode: string;
  defaultLangCode: string;

  homeName: string;
  homeId: string;
  deviceName: string;
  listHistory: ListHistory[] = [];
  lastRecordId: number;
  filterData: any = {pageSize: 25};

  activities = Config.HISTORY_CHECKLISTS;
  sources = [];

  modalRef: BsModalRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    private langService: LanguageChangeService,
    private gdoService: GDOService,
    private modalService: BsModalService
  ) { }

  getDateOnInit() {
    this.fromDate = Date.now() - 2 * 30 * 24 * 60 * 60 * 1000;
    this.toDate = Date.now();
    const offset = new Date().getTimezoneOffset() * 60 * -1;
    this.toDate = this.toDate + offset;
    this.toDate = this.toDate + 2 * 30 * 24 * 60 * 60 * 1000;
  }

  ngOnInit() {
    this.langCode = this.langService.getCurrentLanguage();
    this.defaultLangCode = this.langService.getDefaultLanguage();
    this.getDateOnInit();
    this.activatedRoute.params.subscribe(
      (params) => (this.id = params['id'])
    );
    const deviceState = this.gdoService.getDeviceName(this.id);
    this.deviceName = deviceState.deviceName;
    this.homeId = deviceState.homeId;
    this.homeName = this.gdoService.getHomeName(this.homeId);
    this.filterEvent(this.id, this.filterData);
  }

  private filterEvent(id: string, body: any) {
    this.gdoService.filterGDOEvent(id, body).subscribe({
      next: (res: any) => {
        const data = res?.data;
        if (data?.length > 0) {
          this.orderEventsByMonth(data);
          if (this.listHistory.length > 0) {
            this.filterData.havRecordId = `${id}:${data[data.length - 1].recordId}`;
            this.disableCall = data[data.length - 1].recordId === 0;
            this.showError = false;
          } else {
            this.disableCall = true;
            this.showError = true;
            this.noRecordMsg = this.filters.setFilter
              ? Config.ERROR_MESSAGE.NO_RECORDS_FILTER[this.langCode]
              : Config.ERROR_MESSAGE.NO_RECORDS[this.langCode];
          }
        } else {
          this.disableCall = true;
          this.showError = true;
          this.noRecordMsg = this.filters.setFilter
            ? Config.ERROR_MESSAGE.NO_RECORDS_FILTER[this.langCode]
            : Config.ERROR_MESSAGE.NO_RECORDS[this.langCode];
        }
      },
      error: (err: any) => {
        console.error('Error fetching gets:', err);
      },
    });
  }

  private orderEventsByMonth(events: IGDOHistory[]) {
    const currentDate = new Date();
    const today = currentDate.getDate();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    const eventGroupSet = new Set<number>([1, 3, 4, 5, 6 ,7 , 8 , 9, 10]);
    for (const event of events) {
        if (!eventGroupSet.has(event.eventGroupId) || (event.operationEvent === 0 && event.eventGroupId == 2)) {
          continue; // Skip events that are not in the specified groups
        }

      const date = new Date(event.timeStamp * 1000);
      const month = date.toLocaleString('en-US', { month: 'long' });
      const day = date.getDate();

      this.gdoService.mappingEvent(event, this.langCode, false);

      const isToday = day === today && date.getMonth() === currentMonth && date.getFullYear() === currentYear;
      const monthKey = isToday ? "Today" : month;

      if (!this.listHistory.find((h) => h.month === monthKey)) {
        this.listHistory.push({ month: monthKey, history: [] });
      }
      this.listHistory.find((h) => h.month === monthKey).history.push(event);
    }
  }

  onScroll(event: { currentScrollPosition: number; }) {
    if (this.currentScrollPosition + 250 < event.currentScrollPosition) {
      if (!this.disableCall) {
        this.disableCall = true;
        this.gdoService.filterGDOEvent(this.id, this.filterData).subscribe({
          next: (res: any) => {
            if (res?.data?.length > 0) {
              this.orderEventsByMonth(res.data);
              this.filterData.havRecordId = `${this.id}:${res['data'][res['data'].length - 1].recordId}`
              this.disableCall = (res['data'][res['data'].length - 1].recordId) === 0;
            } else {
              this.disableCall = true;
            }
          },
          error: (err: any) => {
            console.error('Error fetching gets:', err);
          },
        });
    }

    this.currentScrollPosition = event.currentScrollPosition;
    }
  }

  opeFiltersModal() {
    const initialState = {
      id: this.id,
      activities: this.activities,
      sources: this.sources,
      filters: this.filters
    }

    this.modalRef = this.modalService.show(GdoHistoryFilterModalComponent, {
      initialState: initialState,
      class: 'gdo-history-filter',
      ...Constants.MODAL_CONFIG
    });
    this.modalRef.content.closeBtnName = 'Close';

    this.modalRef.content.event.subscribe(filterData => {
      if (filterData) {
        this.pageNo = this.defaultPageNo;
        this.listHistory = [];
        this.filters = filterData;
        this.filters.timestamp = Date.now();
        let gdoFilterActivity: GdoFilterActivity[] = [];
        let gdoFilterUserType: string = '';
        let fromDate = this.gdoService.toMidnightTimestamp(Math.floor(filterData.fromDate));
        let toDate = this.gdoService.toEndDayTimestamp(Math.floor(filterData.toDate));

        filterData.selectedActivities?.forEach(activity => {
          activity.event.forEach(event => {
            gdoFilterActivity.push({eventId: event?.eventId, groupId: event?.groupId, eventBy: event?.eventBy});
          });

        });
        filterData.selectedSource?.forEach(source => {
          gdoFilterUserType = source;
        });

         this.filterData = {
          toDate: toDate,
          fromDate: fromDate,
          havRecordId: this.lastRecordId,
          pageSize: this.pageSize,
          havActivity: gdoFilterActivity,
          havUserType: gdoFilterUserType
        };
        this.filterEvent(this.id, this.filterData);
        this.currentScrollPosition = 0;
      }
    });
    this.modalRef.content.eventClose.subscribe(filterData => {
      if (filterData) {
        console.log('cross modal', filterData);
        this.pageNo = this.defaultPageNo;
        this.filters = filterData;
        this.filters.timestamp = Date.now();
      }
    });
  }


}
